import { Grid } from '@mui/material';
import { AccordionGeneralityForm } from 'civil-status/view-models/accordion-generality-form';
import { Fragment, memo, useMemo } from 'react';
import { FormikErrors, FormikProps, FormikTouched } from 'formik';
import FormGeneralityBase from './base';
import { ConfigurationType } from 'civil-status/constants/configuration-type';
import FormGeneralityBorn from './born';
import { PmiButton } from 'shell/components/shared/button';
import { LastStepVM, ParentVM } from 'civil-status/view-models/step-form';
import { typePresence } from 'civil-status/constants/type-presence';
import { isObjectEmpty } from 'shell/utils/is-object-empty';
import { clearSubjectMomentary } from 'civil-status/utils/clear-subject';
import FormBaseAvv from './base-avv';

const configurationRequiredOnlyNameSurname = Object.freeze([
  ConfigurationType.BASECONI,
  ConfigurationType.CONIOPFI,
  ConfigurationType.BASE02,
  ConfigurationType.OFFI_CIV,
  ConfigurationType.BASE02OPFI,
  ConfigurationType.SEGR_CIV,
  ConfigurationType.OFFI_REL,
  ConfigurationType.OFFI_TRAS,
  ConfigurationType.OFFI_CITT,
  ConfigurationType.OFFI_ACATT,
  ConfigurationType.BASEAVV3,
  ConfigurationType.BASEAVV4,
]);

const configurationRequiredOnlyName = Object.freeze([
  ConfigurationType.SOGMIN,
  ConfigurationType.SOGMINA,
]);

interface FormGeneralityProps {
  formContext: FormikProps<LastStepVM>;
  disabled?: boolean;
  generality?: AccordionGeneralityForm;
  errorsGenerality?: FormikErrors<AccordionGeneralityForm>;
  touchedGenerality?: FormikTouched<AccordionGeneralityForm>;
  onChangeGenerality: (
    key: keyof AccordionGeneralityForm,
    value: AccordionGeneralityForm[keyof AccordionGeneralityForm]
  ) => void;
  onChangeFieldsGenerality: (values: AccordionGeneralityForm) => void;
  configuration?: string;
  presenza?: string;
  codeSubject?: string;
  onSave: () => void;
  valuesMother?: AccordionGeneralityForm;
  valuesFather?: AccordionGeneralityForm;
  onDelete: () => void;
  onClean: (mantainDataGenarality?: AccordionGeneralityForm) => void;
  flagDichiarante?: string;
  flagFirmatario?: string;
  tipoSoggetto?: string;
  withErrors?: boolean;
  dateFormationAct?: string;
  keySubject?: string;
  withReasonDelay?: boolean;
  isSaved?: boolean;
  setDataInterprete: (isWithInterprete?: boolean) => void;
  controllIntNasCivilStatus: (values?: string) => void;
  controllDecedutoCivilStatus: (values?: string) => void;
  controllIsChangeSurnameName: (isChangeSurnameName?: boolean) => void;
  isBaseDec?: boolean;
  isStepFromEmergency?: boolean;
  isLastStepEmergency?: boolean;
  tipoEvento?: string;
}

const FormGeneralityComponent = ({
  formContext,
  disabled,
  generality,
  errorsGenerality,
  touchedGenerality,
  onChangeGenerality,
  onChangeFieldsGenerality,
  configuration,
  presenza,
  codeSubject,
  onSave,
  onClean,
  valuesMother,
  valuesFather,
  onDelete,
  flagDichiarante,
  flagFirmatario,
  tipoSoggetto,
  dateFormationAct,
  keySubject = '',
  withReasonDelay,
  isSaved,
  setDataInterprete,
  controllIntNasCivilStatus,
  controllDecedutoCivilStatus,
  controllIsChangeSurnameName,
  isBaseDec,
  isStepFromEmergency,
  isLastStepEmergency,
  tipoEvento,
}: FormGeneralityProps): React.ReactElement => {
  const currentValue: ParentVM = useMemo(() => {
    return formContext.values[keySubject] as ParentVM;
  }, [formContext.values[keySubject]]);

  // const requiredOnlyNameRic1: boolean = useMemo(() => {
  //   if (configuration !== ConfigurationType.RIC1 && configuration !== ConfigurationType.RIC2) {
  //     return false;
  //   }

  //   if (currentValue.generality?.isRequiredFromOtherAccordion) {
  //     return false;
  //   }

  //   if (
  //     presenza === typePresence.Facoltativo ||
  //     presenza === typePresence.FacoltativoObbligatorio
  //   ) {
  //     const valuesMomentary = { ...(currentValue || {}), ...clearSubjectMomentary(currentValue) };

  //     return !isObjectEmpty((valuesMomentary || {}) as Record<string, unknown>);
  //   }

  //   return false;
  // }, [configuration, currentValue, presenza]);

  const nothingRequired: boolean = useMemo(() => {
    if (
      (presenza === typePresence.Facoltativo ||
        presenza === typePresence.FacoltativoObbligatorio) &&
      !currentValue.generality?.isRequiredFromOtherAccordion &&
      configuration !== ConfigurationType.RIC1 &&
      configuration !== ConfigurationType.RIC2
    ) {
      const valuesMomentary = { ...(currentValue || {}), ...clearSubjectMomentary(currentValue) };

      return isObjectEmpty((valuesMomentary || {}) as Record<string, unknown>);
    }

    if (
      configuration === ConfigurationType.BASETRASC ||
      configuration === ConfigurationType.BASEFOPFI
    ) {
      return true;
    }

    if (
      (presenza === typePresence.Facoltativo ||
        presenza === typePresence.FacoltativoObbligatorio) &&
      (configuration === ConfigurationType.RIC1 || configuration === ConfigurationType.RIC2)
    ) {
      return !currentValue?.generality?.isRequiredFromOtherAccordion;
    }

    if (
      presenza === typePresence.Condizionato &&
      (configuration === ConfigurationType.RIC1 ||
        configuration === ConfigurationType.RIC2 ||
        configuration === ConfigurationType.RIC3 ||
        configuration === ConfigurationType.RIC4 ||
        configuration === ConfigurationType.RIC5 ||
        configuration === ConfigurationType.RIC6 ||
        configuration === ConfigurationType.RIC7)
    ) {
      return !currentValue?.generality?.isRequiredFromOtherAccordion;
    }

    return false;
  }, [configuration, currentValue, presenza]);

  return (
    <Fragment>
      {configuration === ConfigurationType.BASE ||
      configuration === ConfigurationType.BASEANNI ||
      configuration === ConfigurationType.BASEANMD ||
      configuration === ConfigurationType.FIGLIOTRNA ||
      configuration === ConfigurationType.SOGMIN ||
      configuration === ConfigurationType.SOGMINA ||
      configuration === ConfigurationType.BASEMAG ||
      configuration === ConfigurationType.BASERESMI ||
      configuration === ConfigurationType.BASE14 ||
      configuration === ConfigurationType.BASE02 ||
      configuration === ConfigurationType.BASE02A ||
      configuration === ConfigurationType.BASEMIN ||
      configuration === ConfigurationType.BASE02DEC ||
      configuration === ConfigurationType.BASESD ||
      configuration === ConfigurationType.BASEDIR ||
      configuration === ConfigurationType.BASETRASC ||
      configuration === ConfigurationType.BASEFOPFI ||
      configuration === ConfigurationType.SANIT01 ||
      configuration === ConfigurationType.PROCUR01 ||
      configuration === ConfigurationType.BASEDEC ||
      configuration === ConfigurationType.BASESCATTO ||
      configuration === ConfigurationType.BASECONI ||
      configuration === ConfigurationType.OFFI_CIV ||
      configuration === ConfigurationType.OFFI_CITT ||
      configuration === ConfigurationType.OFFI_REL ||
      configuration === ConfigurationType.OFFI_TRAS ||
      configuration === ConfigurationType.OFFI_ACATT ||
      configuration === ConfigurationType.CONIOPFI ||
      configuration === ConfigurationType.INTCIT ||
      configuration === ConfigurationType.INTCIT2 ||
      configuration === ConfigurationType.INTCIT3 ||
      configuration === ConfigurationType.INTCIT4 ||
      configuration === ConfigurationType.BASEG ||
      configuration === ConfigurationType.BASEUC ||
      configuration === ConfigurationType.BASEPERD ||
      configuration === ConfigurationType.BASEOPFI ||
      configuration === ConfigurationType.BASE02OPFI ||
      configuration === ConfigurationType.BASENOINT ||
      configuration === ConfigurationType.BASENOINTR ||
      configuration === ConfigurationType.BASENOINTP ||
      configuration === ConfigurationType.NEOSNOINT ||
      configuration === ConfigurationType.NEOSNOINTP ||
      configuration === ConfigurationType.NEOSPOS ||
      configuration === ConfigurationType.RICH_UCOPF ||
      configuration === ConfigurationType.PERIC_CIV ||
      configuration === ConfigurationType.SEGR_CIV ||
      configuration === ConfigurationType.RIC1 ||
      configuration === ConfigurationType.RIC2 ||
      configuration === ConfigurationType.RIC3 ||
      configuration === ConfigurationType.RIC4 ||
      configuration === ConfigurationType.RIC5 ||
      configuration === ConfigurationType.RIC6 ||
      configuration === ConfigurationType.RIC7 ||
      configuration === ConfigurationType.BASEAVV3 ||
      configuration === ConfigurationType.BASEAVV4 ? (
        <FormGeneralityBase
          formContext={formContext}
          disabled={disabled || isStepFromEmergency}
          generality={generality}
          keySubject={keySubject}
          errorsGenerality={errorsGenerality}
          touchedGenerality={touchedGenerality}
          onClean={onClean}
          onChangeGenerality={onChangeGenerality}
          onChangeFieldsGenerality={onChangeFieldsGenerality}
          setDataInterprete={setDataInterprete}
          controllIntNasCivilStatus={controllIntNasCivilStatus}
          controllDecedutoCivilStatus={controllDecedutoCivilStatus}
          controllIsChangeSurnameName={controllIsChangeSurnameName}
          configuration={configuration}
          codeSubject={codeSubject}
          flagDichiarante={flagDichiarante}
          flagFirmatario={flagFirmatario}
          tipoSoggetto={tipoSoggetto}
          dateFormationAct={dateFormationAct}
          requiredOnlyNameSurname={configurationRequiredOnlyNameSurname.includes(configuration)}
          requiredOnlyName={
            configurationRequiredOnlyName.includes(configuration)
            // || requiredOnlyNameRic1
          }
          nothingRequired={nothingRequired}
          isBaseDec={isBaseDec}
          isStepFromEmergency={isStepFromEmergency}
        />
      ) : undefined}
      {configuration === ConfigurationType.NASC01 ||
      configuration === ConfigurationType.NASC02 ||
      configuration === ConfigurationType.NASC03 ||
      configuration === ConfigurationType.NASC04 ||
      configuration === ConfigurationType.NASC05 ||
      configuration === ConfigurationType.NASC06 ||
      configuration === ConfigurationType.NASC07 ||
      configuration === ConfigurationType.NASC99 ? (
        <FormGeneralityBorn
          disabled={disabled || isStepFromEmergency}
          generality={generality}
          errorsGenerality={errorsGenerality}
          touchedGenerality={touchedGenerality}
          onChangeGenerality={onChangeGenerality}
          onChangeFieldsGenerality={onChangeFieldsGenerality}
          configuration={configuration}
          codeSubject={codeSubject}
          surnameMother={valuesMother?.surname || ''}
          surnameFather={valuesFather?.surname || ''}
          valuesMother={valuesMother}
          valuesFather={valuesFather}
          dateFormationAct={dateFormationAct}
          withReasonDelay={withReasonDelay}
          isSaved={isSaved}
          isLastStepEmergency={isLastStepEmergency}
          tipoEvento={tipoEvento}
        />
      ) : undefined}
      {configuration === ConfigurationType.BASEAVV ||
      configuration === ConfigurationType.BASEAVV2 ? (
        <FormBaseAvv
          disabled={disabled || isStepFromEmergency}
          generality={generality}
          errorsGenerality={errorsGenerality}
          touchedGenerality={touchedGenerality}
          onChangeGenerality={onChangeGenerality}
          onChangeFieldsGenerality={onChangeFieldsGenerality}
          nothingRequired={nothingRequired}
          configuration={configuration}
          dateFormationAct={dateFormationAct}
        />
      ) : undefined}
      <Grid item xs={12} display="flex" justifyContent="center">
        {isStepFromEmergency ? undefined : (
          <PmiButton
            color="cdmBrand"
            variant="outlined"
            onClick={onDelete}
            style={{ marginRight: '1rem' }}
            disabled={disabled}
          >
            Pulisci
          </PmiButton>
        )}
        <PmiButton color="cdmBrandThird" variant="outlined" onClick={onSave} disabled={disabled}>
          Salva
        </PmiButton>
      </Grid>
    </Fragment>
  );
};

FormGeneralityComponent.displayName = 'Form generality component';

const FormGenerality = memo(FormGeneralityComponent);

export default FormGenerality;
